module.exports = __webpack_public_path__ + "static/img/service details_fwbz.50c9ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fuwuxiang/service details_fwbz.png
// module id = /hxG
// module chunks = 1